import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/esm/Card";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import { makeGetRequest } from "../../../../utils/api";
import { urls } from "../../../../utils/urls";
import Button from "react-bootstrap/esm/Button";
import toast, { Toaster } from "react-hot-toast";
import BackToGameList from "../../utils/BackToGameList";

function PhoneRecall() {
  const [play, setPlay] = useState(false);
  const [pregame, setPregame] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [timeoutTrigger, setTimeoutTrigger] = useState(false);
  const [time, setTime] = useState(0);
  const [astInput, setAstInput] = useState(0);
  const [intervalID, setIntervalID] = useState(0);
  const [newKey, setNewKey] = useState();
  const [phoneData, setPhoneData] = useState({});
  const [phoneNumber, setPhoneNumber] = useState();

  const handlePhoneData = async () => {
    const response = await makeGetRequest(urls.phoneRecall, "", true);
    let rnd = Math.floor(Math.random() * response.data.length);
    setPhoneData(response.data[rnd]);
    let settingPhone = response.data[rnd].phone_number.split("");
    let settingPhonef3 = String(settingPhone.slice(0, 3));
    let settingPhonel4 = String(settingPhone.slice(3, 7));
    setPhoneNumber(
      settingPhonef3.replaceAll(",", "") +
        "-" +
        settingPhonel4.replaceAll(",", "")
    );
    setGameOver(false);
    setTimeoutTrigger(false);
    handlePregame();
  };

  useEffect(() => {
    handlePhoneData();
    handlePregame();
  }, []);

  useEffect(() => {
    handleText();
  }, [phoneData]);

  const handlePregame = () => {
    setPlay(true);
    setPregame(true);
    setTime(10);
    setTimeout(() => {
      setTimeoutTrigger(true);
    }, 10000);
  };

  useEffect(() => {
    if (play) {
      const intervalId = setInterval(() => {
        if (play) {
          setTime((prevSeconds) => prevSeconds - 1);
        }
      }, 1000);
      setIntervalID(intervalId);
      return () => clearInterval(intervalId);
    }
  }, [play]);

  useEffect(() => {
    if (timeoutTrigger === true) {
      setPlay(true);
      setTime(120);
      setPregame(false);
    }
  }, [timeoutTrigger]);

  const handleText = (event) => {
    let re = "";
    if (event) {
      if (isNaN(newKey) && newKey !== "Backspace") {
        toast("Try entering a number.", {
          duration: 3000,
          position: "right",
        });
      } else {
        let ast = "";
        let val = event.target.value.replaceAll("*", "");
        val = val.replaceAll("-", "");
        if (String(val).length > String(phoneData.phone_number).length) {
          re = event.target.value.substring(
            0,
            String(phoneData.phone_number).length
          );
          setAstInput(re);
        } else {
          if (newKey === "Backspace") {
            val = val.substring(0, val.length - 1);
            for (
              let i = 0;
              i < String(phoneData.phone_number).length - String(val).length;
              i++
            ) {
              ast = ast + "*";
            }
            re = val + ast;
            re = re.slice(0, 3) + "-" + re.slice(3, 7);
            setAstInput(re);
          } else {
            for (
              let i = 0;
              i < String(phoneData.phone_number).length - String(val).length;
              i++
            ) {
              ast = ast + "*";
            }
            re = val + ast;
            re = re.slice(0, 3) + "-" + re.slice(3, 7);
            setAstInput(re);
          }
        }
      }
    } else {
      let ast = "";
      for (let i = 0; i < String(phoneData.phone_number).length; i++) {
        ast = ast + "*";
      }
      re = ast;
      re = re.slice(0, 3) + "-" + re.slice(3, 7);
      setAstInput(re);
    }
  };

  const checkAnswer = () => {
    let check = astInput.replaceAll("*", "");
    check = check.replaceAll("-", "");
    if (check.length === String(phoneData.phone_number).length) {
      if (check === phoneData.phone_number) {
        toast(
          "Congratulations, the phone number is " + phoneData.phone_number,
          {
            duration: 3000,
            position: "right",
          }
        );
        setTimeout(() => {
          setPlay(false);
          setGameOver(true);
        }, 2000);
      } else {
        toast(
          "It seems that there is a mistake in your phone number. If you need help, please use the Yellow Hint button.",
          {
            duration: 3000,
            position: "right",
          }
        );
      }
    }
  };

  useEffect(() => {
    if (astInput.length === String(phoneData.phone_number).length + 1)
      checkAnswer();
  }, [astInput]);

  const hint = () => {
    if (astInput !== phoneData.phone_number) {
      let astArray = astInput.replaceAll("-", "");
      astArray = astArray.split("");
      let ansArray = phoneData.phone_number.split("");
      let fix = false;

      do {
        for (let i = 0; i < ansArray.length; i++) {
          if (astArray[i] !== ansArray[i]) {
            astArray[i] = ansArray[i];
            fix = true;
            {
              break;
            }
          } else {
            fix = false;
          }
        }
      } while (fix === false);

      let newAst = "";

      for (const val of astArray.values()) {
        newAst = newAst + val;
      }
      newAst = newAst.slice(0, 3) + "-" + newAst.slice(3, 7);
      setAstInput(newAst);
    }
  };

  return (
    <>
      <BackToGameList />
      <Card style={{ marginTop: "50px" }}>
        <Card.Header>
          {!pregame ? (
            <h1 style={{ textAlign: "center" }}>Recall the Phone number</h1>
          ) : (
            <h1 style={{ textAlign: "center" }}>
              Remember the Phone number! <br /> Time Remaining: {time}
            </h1>
          )}
        </Card.Header>
        <Card.Body>
          <Card style={{ padding: "25px" }}>
            {!gameOver ? (
              <>
                {!pregame ? (
                  <div style={{ textAlign: "right" }}>
                    <Button
                      variant="warning"
                      onClick={hint}
                      style={{ width: "100px", marginBottom: "20px" }}
                    >
                      Hint
                    </Button>
                  </div>
                ) : (
                  ""
                )}

                <Row>
                  <h2>
                    <Row>
                      <Col style={{ textAlign: "right" }}>Name:</Col>
                      <Col>
                        {phoneData.first_name} {phoneData.last_name}
                      </Col>
                    </Row>
                  </h2>
                </Row>
                <Row>
                  <h2>
                    <Row>
                      <Col style={{ textAlign: "right" }}>Job:</Col>
                      <Col>{phoneData.job}</Col>
                    </Row>
                  </h2>
                </Row>
                <Row>
                  <h2>
                    <Row>
                      <Col style={{ textAlign: "right" }}>Phone Number:</Col>{" "}
                      <Col>
                        {!pregame ? (
                          <input
                            type="text"
                            onChange={(e) => handleText(e)}
                            onKeyDown={(e) => setNewKey(e.key)}
                            value={astInput}
                          ></input>
                        ) : (
                          phoneNumber
                        )}
                      </Col>
                    </Row>
                  </h2>
                </Row>
              </>
            ) : (
              <>
                {" "}
                <h3>
                  Congratulations! You've successfully remembered the phone
                  number. Please select "Next" to proceed to the next round of
                  Phone Recall.
                </h3>{" "}
                <Button onClick={handlePhoneData}>Next</Button>
              </>
            )}
          </Card>
        </Card.Body>
      </Card>
    </>
  );
}

export default PhoneRecall;
